var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DateTimePicker',{staticClass:"date-time-picker",attrs:{"id":"date-time-picker-input","min":_vm.minimumDate,"max":_vm.maximumDate,"value":_vm.date,"type":_vm.type,"hide-label":true},on:{"input":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }